import { SpreadGroundImage } from '../types';

const setSpreadMasksReducer = (state: any, action: { payload: SpreadGroundImage[] }) => {
  state.spreadMasks = action.payload;
};

export default setSpreadMasksReducer;
